import { render, staticRenderFns } from "./CatalogInstanceCategories.vue?vue&type=template&id=757b6ce2&scoped=true"
import script from "./CatalogInstanceCategories.vue?vue&type=script&lang=ts"
export * from "./CatalogInstanceCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757b6ce2",
  null
  
)

export default component.exports